module.exports = __webpack_public_path__ + "static/media/13b-02_ST-2013-200x300cm-oleo-sobre-papel.382124c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13b/13b-02_ST-2013-200x300cm-oleo-sobre-papel.jpg
// module id = 134
// module chunks = 0